import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-error-modal',
  templateUrl: './generic-error-modal.component.html',
  styleUrls: ['./generic-error-modal.component.css'],
})
export class GenericErrorModalComponent implements OnInit {
  errorString: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: unknown) {}

  ngOnInit() {
    if (this.data instanceof Blob) {
      this.data.text().then((text) => {
        this.errorString = this.extractErrorMessage(text);
      });
      return;
    }

    this.errorString = this.extractErrorMessage(this.data);
  }

  private extractErrorMessage(data: unknown): string {
    if (data == null) {
      return 'Unknown error';
    }
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        return parsed?.message ?? data;
      } catch {
        return data;
      }
    }
    if (typeof data === 'object' && 'message' in data) {
      return String((data as { message: unknown }).message);
    }
    return String(data);
  }
}
